export default function groupBy<T extends object, R extends string | number>(
    collection: T[],
    iteratee: (item: T) => R
) {
    const output: Record<R, T[]> = {} as never;

    collection.forEach((item) => {
        const key = iteratee(item);
        output[key] ||= [];
        output[key].push(item);
    });

    return output;
}
